import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { bookingFavoritesQueryKeys } from "./booking-favorites.query-keys";
import type { BookingFavoritesListResponse } from "./booking-favorites.types";

export function useRemoteFetchBookingFavoritesByFloor(floorInventoryId: number | null | undefined) {
  const id = floorInventoryId ?? null;

  return useRemoteQuery<BookingFavoritesListResponse, RemoteApiError>({
    queryKey:
      id != null
        ? bookingFavoritesQueryKeys.byFloor(id)
        : ([...bookingFavoritesQueryKeys.all, "by-floor", "none"] as const),
    url: "/booking-favorites/by-floor",
    params: id != null ? { floorInventoryId: id } : undefined,
    enabled: id != null
  });
}
